import React from 'react';
import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import cn from '../utils/cn';
import styles from './Input.module.css';

const inputWrapper = cva(styles.root, {
  variants: {
    size: {
      default: styles.sizeDefault,
      small: styles.sizeSmall,
      large: styles.sizeLarge
    }
  },
  defaultVariants: { size: 'default' }
});

const Input = React.forwardRef(function Input(
  { icon, size, className, ...rest },
  ref
) {
  return (
    <div className={cn(inputWrapper({ size }), className)}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <input ref={ref} className={styles.input} {...rest} />
    </div>
  );
});

Input.propTypes = {
  icon: PropTypes.node,
  size: PropTypes.oneOf(['default', 'small', 'large']),
  className: PropTypes.string
};

export default Input;
